import React from 'react';
import { cn } from '../../lib/utils';

const tones = {
  emerald: 'bg-emerald/15 text-emerald border-emerald/30',
  amber: 'bg-emerald/15 text-emerald border-emerald/30',
  zinc: 'bg-white/5 text-zinc-300 border-white/10',
  red: 'bg-red-500/10 text-red-400 border-red-500/30',
  violet: 'bg-emerald/15 text-emerald border-emerald/30',
};

export function Badge({ tone = 'zinc', className, children }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[11px] font-medium uppercase tracking-wide',
        tones[tone],
        className
      )}
    >
      {children}
    </span>
  );
}
